export function searchProperties(obj, query) {
  return _.some(obj, value => {
    if (_.isObject(value)) {
      // Recursively search nested properties
      return searchProperties(value, query);
    } if (_.isString(value) || _.isNumber(value)) {
      // Case-insensitive matching
      return value.toString().toLowerCase().includes(query);
    }
    return false;
  });
}

export function exportToExcel(data, name, mapping ={}) {
  let dataOut = data;
  if (mapping) {
    dataOut = data.map(d => {
      const dOut = {};
      Object.entries(mapping).forEach(([key, label]) => {
        dOut[label] = d[key];
      });
      return dOut;
    });
  }
  const ws = XLSX.utils.json_to_sheet(dataOut);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, name);
  XLSX.writeFile(wb, `${name}.xlsx`);
}
